'use es6';

export const ItemTypes = {
  ITEM: 'UIDraggableListItem'
};